import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-button',
  imports: [],
  templateUrl: './button.html',
  styleUrl: './button.scss',
})
export class Button {
  @Input() type: 'button' | 'submit' | 'reset' = 'button';
  @Input() variant: 'primary' | 'secondary' | 'outline' | 'ghost' = 'primary';
  @Input() size: 'sm' | 'md' | 'lg' = 'md';
  @Input() disabled = false;
  @Input() fullWidth = false;

  get classes(): string {
    const base =
      'inline-flex items-center justify-center font-medium rounded transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2';

    const sizes = {
      sm: 'text-sm px-3 py-1.5',
      md: 'text-base px-4 py-2',
      lg: 'text-lg px-5 py-3',
    };

    const variants = {
      primary: 'bg-primary text-white hover:bg-foreground',
      secondary:
        'bg-secondary text-primary hover:bg-foreground hover:text-white focus:ring-gray-400',
      outline: 'border border-primary text-primary',
      ghost: 'hover:bg-secondary',
    };

    const width = this.fullWidth ? 'w-full' : '';

    return `${base} ${sizes[this.size]} ${variants[this.variant]} ${width}`;
  }
}
